// extracted by extract-css-chunks-webpack-plugin
module.exports = {"Component":"iFUJ_q8K","sub":"cHoQKPX5","footer":"GKym2mE5"};